import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Links from './Links';
import Team from './Team';
import 'semantic-ui-css/semantic.min.css';
import { Icon } from 'semantic-ui-react';
import reportWebVitals from './reportWebVitals';
import { Route, BrowserRouter } from 'react-router-dom'


const app = () =>{
  return(<React.StrictMode>
    <div id="appHeader" style={{display:"flex",justifyContent:"center",width:"100vw",padding:"1%",paddingTop:"2%"}}>
      <h1 style={{fontSize:"2em",fontFamily:"sans-serif",backgroundColor:"lightgreen",padding:"1%",borderRadius:"0.2em",borderBottom:"5px solid black"}}>
        <Icon name="syringe"/>&nbsp;
        Auto - Cowin
      </h1>
    </div>
    <App />
    <div id="appFooter" style={{textAlign:"center",paddingBottom:"10vh"}}>
      <hr style={{width:"8%",color:"InactiveCaption"}}/>
      <h4><a href="https://github.com/abhi887/auto-cowin/issues/new"><Icon name="bug"/>&nbsp;found a bug ? open a issue</a></h4>
      <h4><a href="https://github.com/abhi887/auto-cowin/"><Icon name="github"/>&nbsp;Checkout the project / Code</a></h4>
    </div>
  </React.StrictMode>)
}

const offline = () =>{
  return(<React.StrictMode>
    <div style={{backgroundColor:"#ffffff"}}>
    <div id="appHeader" style={{display:"flex",justifyContent:"center",width:"100vw",padding:"1%",paddingTop:"2%"}}>
      <h1 style={{fontSize:"2em",fontFamily:"sans-serif",backgroundColor:"lightgreen",padding:"1%",borderRadius:"0.2em",borderBottom:"5px solid black"}}>
        <Icon name="syringe"/>&nbsp;
        Auto - Cowin
      </h1>
    </div>
    <center>
      <div id="offline" style={{height:"70vh"}}>
          <h2>Oops ! No internet connection</h2><br/>
          <img id="offline-art" src="offline.gif" alt="device offline UFO art" />
      </div>
    </center>
    <div id="appFooter" style={{textAlign:"center",paddingBottom:"10vh"}}>
      <hr style={{width:"8%",color:"InactiveCaption"}}/>
      <h4><a href="https://github.com/abhi887/auto-cowin/issues/new"><Icon name="bug"/>&nbsp;found a bug ? open a issue</a></h4>
      <h4><a href="https://github.com/abhi887/auto-cowin/"><Icon name="github"/>&nbsp;Checkout the project / Code</a></h4>
    </div>
    </div>
  </React.StrictMode>)
}

const links = ()=>{
  return(<React.StrictMode>
    <div id="appHeader" style={{display:"flex",justifyContent:"center",width:"100vw",padding:"1%",paddingTop:"2%"}}>
      <h1 style={{fontSize:"2em",fontFamily:"sans-serif",backgroundColor:"lightgreen",padding:"1%",borderRadius:"0.2em",borderBottom:"5px solid black"}}>
        <Icon name="syringe"/>&nbsp;
        Auto - Cowin
      </h1>
    </div>  
    <Links />
    <div id="appFooter" style={{textAlign:"center",paddingBottom:"10vh"}}>
      <hr style={{width:"8%",color:"InactiveCaption"}}/>
      <h4><a href="https://github.com/abhi887/auto-cowin/issues/new"><Icon name="bug"/>&nbsp;found a bug ? open a issue</a></h4>
      <h4><a href="https://github.com/abhi887/auto-cowin/"><Icon name="github"/>&nbsp;Checkout the project / Code</a></h4>
    </div>
  </React.StrictMode>)
}

const team = ()=>{
  return(<React.StrictMode>
    <div id="appHeader" style={{display:"flex",justifyContent:"center",width:"100vw",padding:"1%",paddingTop:"2%"}}>
      <h1 style={{fontSize:"2em",fontFamily:"sans-serif",backgroundColor:"lightgreen",padding:"1%",borderRadius:"0.2em",borderBottom:"5px solid black"}}>
        <Icon name="syringe"/>&nbsp;
        Auto - Cowin
      </h1>
    </div>  
    <Team />
    <div id="appFooter" style={{textAlign:"center",paddingBottom:"10vh"}}>
      <hr style={{width:"8%",color:"InactiveCaption"}}/>
      <h4><a href="https://github.com/abhi887/auto-cowin/issues/new"><Icon name="bug"/>&nbsp;found a bug ? open a issue</a></h4>
      <h4><a href="https://github.com/abhi887/auto-cowin/"><Icon name="github"/>&nbsp;Checkout the project / Code</a></h4>
    </div>
  </React.StrictMode>)
}

const routes = (
  < BrowserRouter >
     <div>
        <Route exact path="/" component={app} />
        <Route path="/offline.html" component={ offline } />
        <Route path="/groups" component={ links }/>
        <Route path="/team" component={ team }/>
     </div>
  </ BrowserRouter >
);

ReactDOM.render(routes,document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
